import { render } from "./TopNews.vue?vue&type=template&id=0c6b2333&scoped=true"
import script from "./TopNews.vue?vue&type=script&lang=js"
export * from "./TopNews.vue?vue&type=script&lang=js"

import "./TopNews.vue?vue&type=style&index=0&id=0c6b2333&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6b2333"]])

export default __exports__